import { PRODUCT_LIST, PRODUCT_LIST_FAIL, PRODUCT_LIST_SUCCESS, PRODUCT_STATUS_CHANGE, PRODUCT_STATUS_CHANGE_FAIL, PRODUCT_STATUS_CHANGE_SUCCESS } from "../../actions/admin/customer-actions";
import { call, put, takeLatest, } from "redux-saga/effects";
import { API } from "../../api";

function* ProductList(action) {
    try {
        const response = yield call(API.productList, action.payload);
        yield put({ type: PRODUCT_LIST_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: PRODUCT_LIST_FAIL, payload: { error: error } });
    }
}

function* productStatusChange(action) {
    try {
        const { onSuccess, id, status } = action.payload || {};
        const response = yield call(API.productStatusChange, {
            id,
            status,
        });
        if (typeof onSuccess === "function") {
           onSuccess();
        }
        yield put({ type: PRODUCT_STATUS_CHANGE_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: PRODUCT_STATUS_CHANGE_FAIL, payload: { error: error } });
    }
}

function* productSaga() {
    yield takeLatest(PRODUCT_LIST, ProductList);
    yield takeLatest(PRODUCT_STATUS_CHANGE, productStatusChange);
}
export default productSaga;
